import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { MIN_WIDTH } from '../Layout/enums';
import logo from '../../assets/images/logo_header.svg';
import navArrowLeft from '../../assets/images/nav_arrow_left.svg';
import navArrowRight from '../../assets/images/nav_arrow_right.svg';

import BackArrow from '../Button/BackArrow';
import NotificationList from '../Notifications';
import './index.css';

const BaseDetailScreen =
  ({
    pageHeading,
    pageSubheading,
    pageBottomText,
    backTo,
    backLabel,
    children,
    previousOnClick,
    nextOnClick,
    mediaQueryValues,
    showHeader,
    isBankLink,
  }) => (
    <div>
      <NotificationList />
      <MediaQuery
        maxWidth={MIN_WIDTH.TAB - 1}
        values={mediaQueryValues}
      >
        {showHeader && (
          <div styleName="logoHeader">
            <img
              src={logo}
              alt="My IPO"
              styleName="logoMob"
            />
          </div>)}
      </MediaQuery>
      {showHeader && (
        <div styleName="header">
          <div styleName="headerContainer">
            {backTo && backTo !== '' ? (
              <div>
                <BackArrow to={backTo} label={backLabel} />
              </div>) : null}
            <MediaQuery
              minWidth={MIN_WIDTH.TAB}
              values={mediaQueryValues}
            >
              <img
                src={logo}
                alt="My IPO"
                styleName="logo"
              />
            </MediaQuery>
          </div>
        </div>
      )}
      <div styleName="sectionContainer">
        <div styleName="titleSection">
          <div styleName="pageHeading">{pageHeading}</div>
          { pageSubheading && <div styleName="pageSubheading">{pageSubheading}</div> }
        </div>
        <div styleName="contentRow">
          {previousOnClick ?
            <input
              type="image"
              src={navArrowLeft}
              alt="Previous"
              styleName="navArrowLeft"
              onClick={previousOnClick}
            /> : null }
          <div styleName="contentColumn">
            <div styleName={!isBankLink ? 'pageContent' : ''}>
              {children}
            </div>
            <div styleName="pageBottomText">{pageBottomText}</div>
          </div>
          {nextOnClick ?
            <input
              type="image"
              src={navArrowRight}
              alt="Next"
              styleName="navArrowRight"
              onClick={nextOnClick}
            /> : null }
        </div>
      </div>
    </div>
  );

BaseDetailScreen.propTypes = {
  pageHeading: PropTypes.string,
  pageBottomText: PropTypes.string,
  backTo: PropTypes.string,
  backLabel: PropTypes.string,
  previousOnClick: PropTypes.func,
  nextOnClick: PropTypes.func,
  mediaQueryValues: PropTypes.shape({}),
  showHeader: PropTypes.bool,
  isBankLink: PropTypes.bool,
};

BaseDetailScreen.defaultProps = {
  pageHeading: '',
  pageBottomText: '',
  backTo: '',
  backLabel: '',
  previousOnClick: null,
  nextOnClick: null,
  mediaQueryValues: {},
  showHeader: true,
  isBankLink: false,
};

export default BaseDetailScreen;



// WEBPACK FOOTER //
// ./src/components/BaseDetailScreen/index.js